import axios from "axios";
import Config from "src/config";

const v2_actionChatInternoMensagens = (id, querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat-internal/${id}/mensagens${querys ? querys : ""}`,
    });
};
export default v2_actionChatInternoMensagens;
